import { Stack, Typography } from '@mui/material';

import Dialog from '../../../components/Dialog';
import Button from '../../../components/styledComponents/Button';
import colors from '../../../constants/colors';
import useAnalytics from '../../../hooks/useAnalytics';

interface WithAutoPayDialogProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  onSubmit: () => void;
  buttonValue: string;
}

const WithAutoPayDialog = ({
  open,
  onClose,
  isLoading,
  onSubmit,
  buttonValue,
}: WithAutoPayDialogProps) => {
  const { track } = useAnalytics();

  return (
    <Dialog
      closeDialog={() => {
        track('Link Accessed', {
          category: 'WithAutoPayDialogs',
          event_type: 'Link Accessed',
          link: 'X',
          location: 'Feature Card',
        });
        onClose();
      }}
      data-testid="paymentWithAutoPayDialog"
      open={open}
      title="You’re submitting a payment and setting up AutoPay"
      sx={{
        '& .MuiDialogContent-root': {
          mt: { mobile: 2, tablet: 3 },
        },
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Cabin',
          fontSize: { mobile: 14, tablet: 18 },
          lineHeight: { mobile: '16px', tablet: '18px' },
          letterSpacing: { mobile: 0.2, tablet: 0.4 },
          color: colors.csaaDark,
          mx: { tablet: 1 },
        }}
      >
        Future payments for this policy will be automatically withdrawn on the
        due date with the selected payment method.
      </Typography>
      <Stack sx={{ mt: { mobile: 3, tablet: 5 } }} spacing={1}>
        <Button
          fullWidth
          variant="outlined"
          color="inherit"
          data-testid="withAutoPayDialogGoBackButton"
          sx={{
            borderWidth: 2,
            fontWeight: 700,
            textTransform: 'none',
            color: 'text.secondary',
            px: 4,
            py: 0.5,
          }}
          onClick={() => {
            track('Link Accessed', {
              category: 'WithAutoPayDialogs',
              event_type: 'Link Accessed',
              link: 'Go Back',
              location: 'Feature Card',
            });
            onClose();
          }}
        >
          Go back
        </Button>
        <Button
          fullWidth
          loading={isLoading}
          onClick={onSubmit}
          data-testid="autoPayDialogSubmitButton"
        >
          {buttonValue}
        </Button>
      </Stack>
    </Dialog>
  );
};

export default WithAutoPayDialog;
